<template>
  <div>
    <minimap-markers
      class="minimap"
      id="createMap"
      v-if="$route.name != 'home' || showMinimap"
      style="width: 90%; min-width: 350; max-width: 600px; margin: 0 auto;"
      :mode="'select'"
      :marker="place"
      :newMarker="oldChapter"
      @zoomChanged="form.zoom = $event"
    />
    <div style="width: max-content; margin: 0 auto;">
      <div id="dragm" class="drag" draggable="true" @dragstart="drag" @dragend.prevent="dropOnMap">
        <img
          src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png"
          height="43"
          width="27"
          style="margin: 10px 0.3em;"
        />
        <!-- Me arraste pro mapa para especificar a posição exata da história! -->
        <md-tooltip v-show="!showMinimap">Arraste o marcador para o mapa</md-tooltip>
      </div>
    </div>
    <md-field :class="isValid('position', !!form.position)" class="input-position" >
      <span class="md-helper-text">*Selecione um lugar no mapa ou arraste o marcador</span>
      <span class="md-error">{{mobile ? "Toque" : "Arraste"}} o marcador para selecionar o local</span>
    </md-field>

    <md-field :class="isValid('name')" v-if="!(place && place.id)">
      <md-input ref="formName" v-model="form.placeName" placeholder="Nome do novo lugar" maxlength="100"></md-input>
      <span class="md-helper-text">*Dê um nome para o novo lugar</span>
      <span class="tooltip">
        <md-icon>contact_support</md-icon>
        <md-tooltip>Clique em um marcador para selecionar um lugar</md-tooltip>
      </span>
      <span class="md-error">Dê um nome para o novo lugar</span>
    </md-field>

    <md-field v-else>
      <!-- <md-button @click="clearPlace">Criar lugar</md-button> -->
      <md-input :value="place.name" disabled></md-input>
      <md-icon v-if="$route.name != 'place'" style="cursor: pointer;" @click.native="clearPlace">clear</md-icon>
    </md-field>

    <md-field ref="formTitle" :class="isValid('title')">
      <md-input v-model="form.title" placeholder="Título da história" maxlength="100" required></md-input>
      <span class="md-helper-text">*Coloque um titulo para sua história</span>
      <span class="md-error">Coloque um titulo para sua história</span>
    </md-field>

    <div class="divDates">
      <div>Informe a data da história:</div>

      <md-field class="inputDate">
        <label>Ano</label>
        <md-input placeholder="Ano" type="number" v-model="form.dateStart.year"></md-input>
      </md-field>

      <md-field class="inputDate">
        <label>Mês</label>
        <md-input
          placeholder="Mês"
          type="number"
          :disabled="dateStart.year == ''"
          v-model="form.dateStart.month">
        </md-input>
      </md-field>

      <md-field class="inputDate">
        <label>Dia</label>
        <md-input
          placeholder="Dia"
          type="number"
          :disabled="dateStart.year == '' || dateStart.month == ''"
          v-model="form.dateStart.day">
        </md-input>
      </md-field>
    </div>

    <md-field>
      <label>Capítulo</label>
      <md-textarea class="textareaStory" v-model="form.content" placeholder="Conte sua história!" maxlength="4000"></md-textarea>
    </md-field>

    <div class="divLinks">
      <link-field v-model="form.media" :invalid="invalidFields.media"/>
    </div>

    <a class="adv-btn" @click="advanced = !advanced">>Avançado</a>
    <div class="advanced" v-show="advanced">
      <div class="input-create">
        <div>Data final:</div>
        <md-field class="inputDate">
          <label>Ano</label>
          <md-input placeholder="Ano" type="number" v-model="form.dateEnd.year"></md-input>
        </md-field>

        <md-field class="inputDate">
          <label>Mês</label>
          <md-input
            placeholder="Mês"
            type="number"
            :disabled="dateEnd.year == ''"
            v-model="form.dateEnd.month">
          </md-input>
        </md-field>

        <md-field class="inputDate">
          <label>Dia</label>
          <md-input
            placeholder="Dia"
            type="number"
            :disabled="dateEnd.year == '' || dateEnd.month == ''"
            v-model="form.dateEnd.day">
          </md-input>
        </md-field>

      </div>

      <div class="input-create">
        <div>Visibilidade:</div>
        <md-radio class="md-primary" v-model="form.visibility" value="0">Público</md-radio>
        <md-radio class="md-primary" v-model="form.visibility" value="1" disabled>
          <i>Amigos</i>
        </md-radio>
        <md-radio class="md-primary" v-model="form.visibility" value="2" disabled>
          <i>Privado</i>
        </md-radio>
      </div>
    </div>
  </div>
</template>

<script>
import minimapMarkers from "@/components/drawer/maps/minimapMarkers";
import linkField from "./linkField";
import dateHelper from "@/assets/js/date";
import bus from "@/api/bus";

export default {
  components: {
    minimapMarkers,
    linkField
  },
  props: ['place', 'oldChapter', 'showMinimap'],
  data() {
    return {
      form: {
        placeName: "",
        title: "",
        content: "",
        dateStart: { year: "", month: "", day: "" },
        dateEnd: { year: "", month: "", day: "" },
        visibility: "0",
        position: null,
        zoom: false,
        media: null
      },
      invalidFields: {
        place: [],
        chapter: [],
        media: []
      },
      advanced: false
    };
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    dateStart() {
      return this.form.dateStart;
    },
    dateEnd() {
      return this.form.dateEnd;
    },
    chapter() {
      return {
        title: this.form.title || "",
        content: this.form.content || "",
        position: this.form.position || (this.place && this.place.position) || null,
        media: this.form.media || null,
        author: this.user && this.user.id,
        visibility: this.form.visibility || "0",
        dateStart: dateHelper.trimDateStart(this.dateStart) || null, //Data de ocorrência da história
        dateEnd: dateHelper.trimDateEnd(this.dateEnd, this.dateStart) || null //Data final da história
      };
    },
    group() {
      return {
        name: this.form.placeName,
        position: this.form.position,
        zoom: this.form.zoom || this.$route.params.zoom,
        author: this.user && this.user.id,
        dateStart: dateHelper.trimDateStart(this.dateStart) || null,
        dateEnd: dateHelper.trimDateEnd(this.dateEnd, this.dateStart) || null
      };
    },
    mobile() {
      return window.innerWidth <= 600;
    }
  },
  watch: {
    dateStart: {
      handler(date) {
        let today = new Date();
        // sets dateEnd to dateStart when dateStart changes if not advanced
        if (!this.advanced && this.dateEnd.year != "" && this.oldChapter == null) {
          ["year", "month", "day"].map(key => (this.form.dateEnd[key] = date[key]));
        }
        // sets dateEnd min to dateStart if advanced
        if (this.advanced) {
          dateHelper.minDate(this.form.dateEnd, date);
        }

        // limits max date to current day
        dateHelper.maxDate(date, today);

        // limits month and day to valid calendar dates
        dateHelper.valiDate(date);
      },
      deep: true
    },
    dateEnd: {
      handler(date) {
        let today = new Date();
        // limits min date to dateStart
        dateHelper.minDate(date, this.dateStart);

        // limits max date to current day
        dateHelper.maxDate(date, today);

        // limits month and day to valid calendar dates
        dateHelper.valiDate(date);
      },
      deep: true
    },
    chapter: {
      handler(chap) {
        this.$emit('newChapter', chap);
      },
      deep: true
    },
    group: {
      handler(place) {
        this.$emit('newPlace', place);
      },
      deep: true
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.setListeners();
  },
  methods: {
    setListeners() {
      this.form.position = this.place && this.place.position;
      bus.on.position(position => (this.form.position = position));
      bus.on.mapZoom(zoom => (this.form.zoom = zoom));
      bus.on.invalidData(data => {
        if (data.chapter.includes("position"))
          document.querySelector([".md-dialog-content", ".createSidebar"]).scrollTo(0, 0);
        else if (data.place.includes("name"))
          this.$refs.formName.$el.focus();
        else if (data.chapter.includes("title"))
          this.$refs.formTitle.$el.focus();
        return this.invalidFields = data;
      });
      this.addTouchEvent();
    },
    loadData() {
      if (!this.oldChapter)
        return ;
      this.form.title = this.oldChapter.title;
      this.form.position = this.oldChapter.position;
      this.form.zoom = this.place && this.place.zoom;
      this.form.dateStart = this.dateToObj(this.oldChapter.dateStart);
      this.form.dateEnd = this.dateToObj(this.oldChapter.dateEnd);
      this.form.content = this.oldChapter.content;
      this.form.media = this.oldChapter.media;
      this.form.visibility = this.oldChapter.visibility;
    },
    drag(event) {
      let img = document.createElement("img");
      img.src = "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png";
      event.dataTransfer.setDragImage(img, 24, 43);
      event.dataTransfer.effectAllowed = "all";
    },
    dropOnMap(event) {
      // event.dataTransfer.dropEffect = "copy";
      bus.emit.createMarker(event);
    },
    addTouchEvent() {
      let map = document.getElementById("dragm");
      map.addEventListener("touchstart", () => {
        bus.emit.newMarker();
      })
    },

    dateToObj(date) {
      let d = new Date(date);
      return {
        year: date?  d.getFullYear() : "",
        month: date?  d.getMonth() + 1 : "",
        day: date?  d.getDate() : ""
      }
    },

    isValid(field, pass = false) {
      return {
        'md-invalid': !pass && (this.invalidFields.place.includes(field) || this.invalidFields.chapter.includes(field))
      };
    },

    clearPlace() {
      bus.emit.clearPlace();
    }
  }
};
</script>

<style scoped>
.allCreate {
  height: 100vh;
  width: 100vw;
}

.submit {
  display: flex;
  justify-content: center;
}

.drag {
  cursor: grab;
}

.divMaps {
  position: relative;
  float: left;
  width: 45%;
  /* background-color: purple; */
  margin-right: 1em;
}

.card-minimap-create {
  position: relative;
  width: 100%;
  margin: 1em auto;
}

.minimap {
  top: 0;
  height: 60vw;
  max-height: 50vh;
  max-width: 800px;
  margin: 4% auto;
}

.upload-btn-wrapper {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper:hover,
.upload-btn-wrapper:hover > .insert-photo {
  border-color: #6747c7;
  color: #6747c7;
  background-color: white;
  cursor: pointer;
}

.inputText {
  margin-top: 5px;
  width: 100%;
}

.md-tooltip {
  z-index: 15;
}

.input-position {
  min-height: unset;
  padding: 0;
  margin-top: 0;
}

.input-date {
  margin-top: 5px;
  float: left;
  width: 25%;
  margin: 0 3% 0 0;
}

.input-place {
  display: flex;
}

.md-checkbox-label {
  transform: translateY(-40%);
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
    -moz-appearance:textfield;
}

.input-story {
  width: 100%;
}

.tooltip {
  margin: 0 0.5em;
}

.textareaStory {
  min-height: 350px!important;
  max-height: 1000px;
}

.divLinks {
  margin: 3em auto;
}

.adv-btn {
  cursor: pointer;
  color: var(--md-theme-default-primary) !important;
}

.advanced {
  display: flex;
  margin: 2em auto;
}

.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.divDates{
  width: 100%;
}

.inputDate{
  width: 20%;
  float: left;
  margin-right: 1em;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
